module.exports = __webpack_public_path__ + "static/img/project.b80f3b3.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/image/project.png
// module id = xI8T
// module chunks = 1